/**
 * Flow row preview weight — inline current → optimal + Δ when overlay is on.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

import {
  usePreviewMode,
} from '@/features/flow-optimizer/components/preview/PreviewIndexContext';
import PreviewWeightCells from '@/features/flow-optimizer/components/preview/PreviewWeightCells';
import {
  showExcludedBadge,
  type PreviewRow,
} from '@/features/flow-optimizer/components/preview/preview-row.types';

export function useFlowRowPreviewLocked(
  previewRow: PreviewRow | null,
  active: boolean,
): boolean {
  const previewMode = usePreviewMode();
  return previewMode && previewRow != null && !showExcludedBadge(previewRow, active);
}

export interface FlowRowPreviewWeightProps {
  previewRow: PreviewRow | null;
  active: boolean;
  fallback: ReactNode;
}

export const FlowRowPreviewWeight: FC<FlowRowPreviewWeightProps> = ({
  previewRow,
  active,
  fallback,
}) => {
  const locked = useFlowRowPreviewLocked(previewRow, active);
  if (locked && previewRow) {
    return (
      <div className="grid grid-cols-[3rem_0.75rem_3rem_3.25rem] items-center gap-x-1.5">
        <PreviewWeightCells row={previewRow} />
      </div>
    );
  }
  return fallback;
};
